export const PERCENT = 'percent';
export const FIXED = 'fixed';
